import { BIBLE_CATEGORIES_EN, BIBLE_CATEGORIES_ZH } from "./bibleCategories";

const flattenCanonicalBooks = (categories) =>
  [...categories.ot, ...categories.nt]
    .filter((cat) => cat.id !== "all" && Array.isArray(cat.books))
    .flatMap((cat) => cat.books);

export const BOOKS_ZH = flattenCanonicalBooks(BIBLE_CATEGORIES_ZH);
export const BOOKS_EN = flattenCanonicalBooks(BIBLE_CATEGORIES_EN);

// Protestant canon chapter counts, aligned with BOOKS_ZH / BOOKS_EN order.
export const CANONICAL_CHAPTER_COUNTS = [
  50, 40, 27, 36, 34, 24, 21, 4, 31, 24, 22, 25, 29, 36, 10, 13, 10, 42, 150,
  31, 12, 8, 66, 52, 5, 48, 12, 14, 3, 9, 1, 4, 7, 3, 3, 3, 2, 14, 4, 28, 16,
  24, 21, 28, 16, 16, 13, 6, 6, 4, 4, 5, 3, 6, 4, 3, 1, 13, 5, 5, 3, 5, 1, 1,
  1, 22,
];

export const buildChapterId = (bookIndex, chapterNumber) => {
  const book = Number(bookIndex);
  const chapter = Number(chapterNumber);
  if (!Number.isFinite(book) || book < 1 || !Number.isFinite(chapter) || chapter < 1) {
    return "";
  }
  return `${book}-${chapter}`;
};

export const getCanonicalChapterCount = (bookIndex) => {
  const index = Number(bookIndex);
  if (!Number.isFinite(index) || index < 1) return 1;
  return CANONICAL_CHAPTER_COUNTS[index - 1] || 1;
};

export const resolveBookIndex = ({ chapterId, bookName } = {}) => {
  const parsed = parseChapterId(chapterId);
  if (parsed.bookIndex) return parsed.bookIndex;
  const name = formatStoredBookName(bookName);
  if (!name) return null;
  const zh = BOOKS_ZH.indexOf(name);
  if (zh >= 0) return zh + 1;
  const en = BOOKS_EN.indexOf(name);
  if (en >= 0) return en + 1;
  return null;
};

export const formatNarrowChapterChip = ({ bookName, chapterNumber, total } = {}) => {
  const book = String(bookName || "").trim() || "圣经";
  const chapter = Number(chapterNumber) || 1;
  const totalChapters = Number(total) || 0;
  return totalChapters > 0 ? `${book} ${chapter}/${totalChapters}` : `${book} ${chapter}`;
};

export const parseChapterId = (chapterId) => {
  const match = String(chapterId || "").trim().match(/^(\d+)-(\d+)$/);
  if (!match) {
    return { bookIndex: null, chapterNumber: null };
  }
  return {
    bookIndex: Number(match[1]),
    chapterNumber: Number(match[2]),
  };
};

export const getBookNameByIndex = (bookIndex, isEn = false) => {
  const index = Number(bookIndex);
  if (!Number.isFinite(index) || index < 1) return "";
  const list = isEn ? BOOKS_EN : BOOKS_ZH;
  return list[index - 1] || "";
};

export const getBookNameByChapterId = (chapterId, isEn = false) => {
  const { bookIndex } = parseChapterId(chapterId);
  return getBookNameByIndex(bookIndex, isEn);
};

export const formatStoredBookName = (name) => {
  const raw = String(name || "").trim();
  if (!raw) return "";
  return raw.includes("-") ? raw.split("-").slice(1).join("-") : raw;
};

export const getLocalizedBookName = ({ chapterId, bookName } = {}, isEn = false) => {
  return getBookNameByChapterId(chapterId, isEn) || formatStoredBookName(bookName);
};

export const formatChapterChipLabel = (item, isEn = false) => {
  const parsed = parseChapterId(item?.chapterId);
  const book = getLocalizedBookName(item, isEn);
  const chapterNumber = parsed.chapterNumber || item?.chapterNumber || 1;
  if (!book) {
    return isEn ? `Chapter ${chapterNumber}` : `${chapterNumber}章`;
  }
  return isEn ? `${book} ${chapterNumber}` : `${book} ${chapterNumber}章`;
};

export const formatContinueChapterTitle = (item, isEn = false) => {
  const parsed = parseChapterId(item?.chapterId);
  const book = getLocalizedBookName(item, isEn);
  const chapterNumber = parsed.chapterNumber || item?.chapterNumber || 1;
  if (!book) {
    return isEn ? `Chapter ${chapterNumber}` : `第 ${chapterNumber} 章`;
  }
  return isEn ? `${book} Chapter ${chapterNumber}` : `${book} 第 ${chapterNumber} 章`;
};
